import { notify } from '../../actions/notifications';
import { toggleFavoriteOffersFromHistory } from '../../actions/offersFromHistory';
import {
  TDeleteOfferFromFavoritesResponse,
  fetchDeleteOfferFromFavorites,
} from '../../repositories/favorites/v1/delete-offer-from-favorites';
import { ENotificationStyle } from '../../types/notifications';
import { TRecentlyViewedOffer } from '../../types/recentlyViewedOffer';
import { TThunkAction } from '../../types/redux';

export const deleteFromFavorite =
  ({ dealType, offerId, entityType }: TRecentlyViewedOffer): TThunkAction<Promise<void>> =>
  async (dispatch, _, { httpApi, logger }) => {
    dispatch(toggleFavoriteOffersFromHistory({ offerId, isFavorite: false }));

    const showError = () =>
      dispatch(notify('Не удалось удалить недавно просмотренное объявление из избранного', ENotificationStyle.Error));

    try {
      const { statusCode, response }: TDeleteOfferFromFavoritesResponse = await fetchDeleteOfferFromFavorites({
        httpApi,
        parameters: {
          dealType,
          entityId: offerId,
          entityType,
        },
      });

      if (statusCode !== 200) {
        dispatch(toggleFavoriteOffersFromHistory({ offerId, isFavorite: true }));

        showError();
        logger.warning(response.message || 'Fail to remove recently viewed from favorites');
      }
    } catch (e) {
      dispatch(toggleFavoriteOffersFromHistory({ offerId, isFavorite: true }));

      showError();
      logger.error(e, {
        description: 'Fail to remove recently viewed from favorites',
      });
    }
  };
